import type { ToolMeta } from './registry';

export const getCoachReferenceMeta = {
  description:
    'Read a curated, UK-figure-dense coach reference for a common wedding topic (local, fast).',
  examples: [
    'How should we split our budget?',
    'When do we need to book the photographer?',
    "What's the legal process for getting married?",
  ],
  value: 'a grounded answer on budgets, timings, guests, or the legal side',
} as const satisfies ToolMeta;
